var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import batchImport from '../../components/contract/contract-batch-import.vue';
import singleImport from '../../components/repayment/single-import.vue';
import commonVideo from '../../components/console-common/common-video.vue';
export default Vue.extend({
    name: 'login',
    components: {
        batchImport: batchImport,
        singleImport: singleImport,
        'el-common-video': commonVideo,
    },
    computed: __assign({}, mapState('repayment', [
        'tabActiveName',
        'isDisabledImport',
        'isDefaultStatus',
    ])),
    data: function () {
        return {
            repayment: 'repayment',
            activeName: 'batch',
        };
    },
    created: function () {
        this.initImport();
    },
    beforeRouteLeave: function (to, from, next) {
        var _this = this;
        if (!this.isDisabledImport && this.isDefaultStatus) {
            this.$confirm('', '', {
                message: "<p class=\"title\">\u5373\u5C06\u79BB\u5F00\u6DFB\u52A0\u8FD8\u6B3E\u8BA1\u5212\u9875</p><p class=\"text\">\u60A8\u521B\u5EFA\u7684\u8FD8\u6B3E\u8BA1\u5212\u8FD8\u672A\u5BFC\u5165\uFF0C\u82E5\u70B9\u51FB\u79BB\u5F00\uFF0C\u7CFB\u7EDF\u5C06\u4E0D\u4F1A\u4FDD\u5B58\u60A8\u521B\u5EFA\u7684\u8FD8\u6B3E\u8BA1\u5212\u3002</p>",
                dangerouslyUseHTMLString: true,
                distinguishCancelAndClose: false,
                showClose: false,
                confirmButtonText: '我再想想',
                cancelButtonText: '离开',
                type: 'warning',
            })
                .then(function () { })
                .catch(function () {
                _this.$store.commit('repayment/update', {
                    isDisabledImport: true,
                    isDefaultStatus: true,
                    tabActiveName: 'batch',
                });
                next();
            });
        }
        else {
            next();
        }
    },
    methods: {
        initImport: function () {
            var contractCode = this.$route.params.contractCode;
            this.$store.commit('repayment/update', {
                tabActiveName: contractCode ? 'single' : 'batch',
                contractCode: contractCode || '',
            });
            this.activeName = this.tabActiveName;
        },
        updateTabActiveName: function (tabActiveName) {
            this.$store.commit('repayment/update', {
                tabActiveName: tabActiveName,
            });
        },
    },
    watch: {
        tabActiveName: function (val) {
            this.activeName = val;
        },
    },
});
